namespace RioERP.Inventory {
    export interface PendriveOutwardRow {
        Id?: number;
        PenDriveTypeId?: number;
        OpeningBalance?: number;
        TotalInward?: number;
        TotalOutward?: number;
        BalanceQuantity?: number;
        OutwardMonth?: string;
        Notes?: string;
        IsActive?: boolean;
        PendriveType?: string;
        InsertUserId?: number;
        InsertDate?: string;
        UpdateUserId?: number;
        UpdateDate?: string;
    }

    export namespace PendriveOutwardRow {
        export const idProperty = 'Id';
        export const nameProperty = 'PendriveType';
        export const localTextPrefix = 'Inventory.PendriveOutward';
        export const deletePermission = 'Inventory:InventoryManagement:Modify';
        export const insertPermission = 'Inventory:InventoryManagement:Modify';
        export const readPermission = 'Inventory:InventoryManagement:View';
        export const updatePermission = 'Inventory:InventoryManagement:Modify';

        export declare const enum Fields {
            Id = "Id",
            PenDriveTypeId = "PenDriveTypeId",
            OpeningBalance = "OpeningBalance",
            TotalInward = "TotalInward",
            TotalOutward = "TotalOutward",
            BalanceQuantity = "BalanceQuantity",
            OutwardMonth = "OutwardMonth",
            Notes = "Notes",
            IsActive = "IsActive",
            PendriveType = "PendriveType",
            InsertUserId = "InsertUserId",
            InsertDate = "InsertDate",
            UpdateUserId = "UpdateUserId",
            UpdateDate = "UpdateDate"
        }
    }
}
